export default __webpack_public_path__ + "static/media/project7.7903dc4e.webp";